import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useAgGridCommon } from 'common/table/agGrid/AgGridCommon';
import { common } from 'utils/agGrid/options';
import { useAppSelector } from 'hooks/useAppSelector';
import { createLoadingSelector } from 'erisxkit/client';
import { ACCOUNTS } from 'constants/actionTypes';

interface ReconciliationHistoryGridProps {
  data: ReconciliationHistoryDataType[];
  colDefs: ColDef[];
  viewReconciliationHistory: (id: string) => void;
}
export interface ReconciliationHistoryDataType {
  uuid: string;
  endTime: string;
  state: string;
  startTime: string;
  endExternalBalance: string;
  endInternalBalance: string;
}

export const gridName = 'reconciliation-history';

const ReconciliationHistoryGrid: React.FC<ReconciliationHistoryGridProps> = ({
  data,
  colDefs,
  viewReconciliationHistory,
}) => {
  const gridRef = useRef<AgGridReact>(null);
  const [rowData, setRowData] = useState<ReconciliationHistoryDataType[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);

  useEffect(() => {
    setColumnDefs(colDefs);
  }, [colDefs]);

  const { gridVisible, initialGridSettings, onStateUpdated } = useAgGridCommon({
    gridName,
  });

  useEffect(() => {
    setRowData(data);
    if (!initialGridSettings?.columnSizing) {
      gridRef.current?.api?.sizeColumnsToFit();
    }
  }, [data]);

  const onRowClicked = useCallback(
    ({ data }: { data: ReconciliationHistoryDataType }) => {
      const uuid = data?.uuid;
      viewReconciliationHistory(uuid || '');
    },
    [viewReconciliationHistory],
  );

  const loading = useAppSelector((state) =>
    createLoadingSelector([ACCOUNTS])(state),
  );

  return (
    <div className="ag-theme-quartz">
      {gridVisible && (
        <AgGridReact
          loading={loading}
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          gridOptions={common}
          onStateUpdated={onStateUpdated}
          initialState={initialGridSettings}
          onRowClicked={onRowClicked}
        />
      )}
    </div>
  );
};

export default ReconciliationHistoryGrid;
